module.exports = __webpack_public_path__ + "static/media/green_chip_icon.dc0b4b70.svg";